<mat-checkbox
  [formControl]="control"
  [id]="id"
  [attr.name]="name"
  [ngClass]="fieldClass"
  [labelPosition]="labelPosition"
>
  <span class="pt-1 fw-normal">
    {{ label }}
  </span>
</mat-checkbox>
<mat-error siatErrorField [control]="control" [label]="label"></mat-error>
